<div class="p-2 pb-5">
    <div class="d-flex justify-content-between mb-2">
        <h3 class="mb-0">Manage Hot Game</h3>
        <button class="btn btn-primary btn-sm" (click)="save()" *ngIf="!loading">Save</button>
    </div>
    <div class="height">
        <div class="d-flex justify-content-center" *ngIf="loading">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <table class="table table-bordered table-sm" *ngIf="!loading">
            <thead>
                <tr>
                    <td></td>
                    <th>No</th>
                    <th>Supplier</th>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Animate</th>
                </tr>
                <tr>
                    <th colspan="2"></th>
                    <th><input type="text" class="form-control form-control-sm" placeholder="Search Supplier" (input)="searchSupplier($event)" /></th>
                    <th><input type="text" class="form-control form-control-sm" placeholder="Search Type" (input)="searchType($event)" /></th>
                    <th><input type="text" class="form-control form-control-sm" placeholder="Search Name" (input)="searchName($event)" /></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let game of games; let i = index">
                    <td><input type="checkbox" class="form-check-input" [id]="'game_' + i" [name]="'game_' + i" [ngModel]="game.checked" value="1" (change)="gameChecked(game)" /></td>
                    <td>{{i +  1}}</td>
                    <td><label [for]="'game_' + i">{{game.platform}}</label></td>
                    <td><label [for]="'game_' + i">{{game.category}}</label></td>
                    <td><label [for]="'game_' + i">{{game.name}}</label></td>
                    <td><input type="checkbox" class="form-check-input" [id]="'game_animate_' + i" [name]="'game_animate_' + i" [ngModel]="game.animate" value="1" (change)="animateChecked(game)" /></td>
                </tr>
            </tbody>
        </table>
    </div>
    <button class="btn btn-primary btn-sm w-100 position-absolute bottom-0 start-0" (click)="save()" *ngIf="!loading">Save</button>
</div>